import QueryEmail from "../users/query-email";

export default QueryEmail
